import React, { useCallback, useState, CSSProperties, forwardRef } from 'react';
import { useCollection } from '@nandorojo/swr-firestore';
import { COUPLE_SUB_COL } from '@typings/couple/coupleSubCol';
import ImgCard from './ImgCard';
import {
  CoupleSecWrapper,
  CoupleInfo,
  InfoDecoBar,
  CoupleText,
} from './CoupleItemStyle';
import Name from './Name';
import {
  IcoupleDetailItem,
  IcoupleThumbnail,
} from '@typings/couple/couple.interface';
import { ACCESS_TYPE } from '@typings/common/accessType';
import { replaceContents } from '@utils/replaceContents';
import CoupleEditBtnSec from './CoupleEditBtnSec';
import { useDDay } from '@hooks/useDday';

type Props = {
  collectionPath?: string;
  data?: IcoupleDetailItem;
  isEdit?: boolean;
  style?: CSSProperties;
};

function CoupleItem(
  { data, collectionPath, isEdit, style, ...props }: Props,
  ref,
) {
  if (!data) return null;

  const { data: rightThumbList } = useCollection<IcoupleThumbnail>(
    `${collectionPath}/${data.id}/${COUPLE_SUB_COL.RIGHT_THUMB}`,
    { listen: true, orderBy: ['order', 'asc'] },
  );
  const { data: leftThumbList } = useCollection<IcoupleThumbnail>(
    `${collectionPath}/${data.id}/${COUPLE_SUB_COL.LEFT_THUMB}`,
    { listen: true, orderBy: ['order', 'asc'] },
  );
  // dday -------------------------------------------------------
  const { targetDate, character, themeSet } = data;

  const { sign, day } =
    useDDay({
      fromDate: targetDate,
    }) || {};

  // dday end ----------------------------------------------------

  const [randomIndex, setRandomIndex] = useState(0);

  const handleNext = useCallback(
    (e) => {
      e.preventDefault();
      if (rightThumbList) {
        setRandomIndex((prevState) =>
          prevState < rightThumbList.length - 1 ? prevState + 1 : 0,
        );
      }
    },
    [rightThumbList],
  );

  const leftImg =
    leftThumbList && leftThumbList![randomIndex]
      ? leftThumbList![randomIndex].imgURL
      : '';

  const rightImg =
    rightThumbList && rightThumbList![randomIndex]
      ? rightThumbList![randomIndex].imgURL
      : '';

  return (
    <>
      <CoupleSecWrapper
        bgColor={themeSet?.backgroundColor}
        ref={ref}
        style={style}
        data-sound-type="card"
        {...props}
      >
        <ImgCard
          imgURL={leftImg}
          name={character?.left.name || ''}
          dir="bottom"
          bgColor={themeSet?.backgroundColor}
          textColor={themeSet?.textColor}
        />

        <ImgCard
          imgURL={rightImg}
          name={character?.right.name || ''}
          dir="top"
          bgColor={themeSet?.backgroundColor}
          textColor={themeSet?.textColor}
        />
        <Name
          textColor={themeSet?.textColor}
          rightName={character?.right.name || ''}
          leftName={character?.left.name || ''}
          accessType={data?.accessType || ACCESS_TYPE.PUBLIC}
        />

        <CoupleInfo
          whileTap={{ scale: 0.9 }}
          onClick={handleNext}
          className="coupleInfo"
          themeSet={themeSet}
        >
          {!data.showDday ? (
            <CoupleText
              dangerouslySetInnerHTML={{
                __html: data.coupleText
                  ? replaceContents(data.coupleText)
                  : 'notitle',
              }}
            />
          ) : (
            <>
              <h3>{day}</h3>
              <span>DAY</span>
            </>
          )}
          <InfoDecoBar color={themeSet?.textColor || 'var(--textColor)'} />
        </CoupleInfo>
      </CoupleSecWrapper>

      {isEdit && (
        <CoupleEditBtnSec data={data} collectionPath={collectionPath} />
      )}
    </>
  );
}

export default forwardRef(CoupleItem);
